"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatContactDescription = exports.formatContactName = void 0;

var _formatName = _interopRequireDefault(require("I18n/utils/formatName"));

var _filter = _interopRequireDefault(require("transmute/filter"));

var _get = _interopRequireDefault(require("transmute/get"));

var _getIn = _interopRequireDefault(require("transmute/getIn"));

var _map = _interopRequireDefault(require("transmute/map"));

var _pipe = _interopRequireDefault(require("transmute/pipe"));

var formatContactName = function formatContactName(contact) {
  var firstName = (0, _getIn.default)(['properties', 'firstname', 'value'], contact) || '';
  var lastName = (0, _getIn.default)(['properties', 'lastname', 'value'], contact) || '';
  var email = (0, _getIn.default)(['properties', 'email', 'value'], contact);
  var fullName = (0, _formatName.default)({
    firstName: firstName,
    lastName: lastName
  });

  if (fullName != null && fullName.length > 0) {
    return fullName;
  } else {
    return email;
  }
};

exports.formatContactName = formatContactName;
var formatContactDescription = (0, _pipe.default)((0, _getIn.default)(['identity-profiles', 0, 'identities']), (0, _filter.default)(function (identity) {
  return (0, _get.default)('type', identity) === 'EMAIL';
}), (0, _map.default)((0, _get.default)('value')), function (emailValues) {
  return emailValues.join(', ');
});
exports.formatContactDescription = formatContactDescription;